"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_datepicker_1 = require("react-datepicker");
var react_hook_form_1 = require("react-hook-form");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
require("./date-picker.scss");
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DatePicker.prototype.render = function () {
        var _a = this.props, dateProps = _a.dateProps, className = _a.className, placeholderText = _a.placeholderText, disabled = _a.disabled, inputRef = _a.inputRef, useHookResponse = _a.useHookResponse, name = _a.name;
        var control = useHookResponse.control;
        return (React.createElement("div", { className: "date-picker" },
            React.createElement(react_hook_form_1.Controller
            // @ts-ignore
            , { 
                // @ts-ignore
                as: react_datepicker_1.default, control: control, valueName: "selected" // DateSelect value's name is selected
                , onChange: function (_a) {
                    var selected = _a[0];
                    return selected;
                }, name: name, showMonthDropdown: true, showYearDropdown: true, minDate: dateProps === null || dateProps === void 0 ? void 0 : dateProps.minDate, maxDate: dateProps === null || dateProps === void 0 ? void 0 : dateProps.maxDate, className: className, placeholderText: placeholderText }),
            React.createElement("div", { className: "calendar" },
                React.createElement(teamsnap_ui_1.Icon, { name: "schedule" }))));
    };
    return DatePicker;
}(React.PureComponent));
exports.default = DatePicker;
DatePicker.defaultProps = {
    placeholderText: "Select date",
};
//# sourceMappingURL=date-picker.js.map